import { SAILS_APP_NAME } from '../../constant';
import { OptionVO } from './types';

import { getRaLocale } from './utils/getLocale';

/** NAMESPACE */
export const NAMESPACE = 'ROAMING_ADVISOR';
/** MARKUP_ID */
export const MARKUP_ID = 'sails-roaming-advisor';

/** SET_DEFAULT_STATE */
export const SET_DEFAULT_STATE = `${SAILS_APP_NAME}/SET_DEFAULT_STATE`;
/** SET_DEFAULT_STATE_SUCCESS */
export const SET_DEFAULT_STATE_SUCCESS = `${SAILS_APP_NAME}/SET_DEFAULT_STATE_SUCCESS`;
/** SET_DEFAULT_STATE_FAILED */
export const SET_DEFAULT_STATE_FAILED = `${SAILS_APP_NAME}/SET_DEFAULT_STATE_FAILED`;
/** SET_DESTINATION */
export const SET_DESTINATION = `${SAILS_APP_NAME}/SET_DESTINATION`;
/** SET_COUNTRY */
export const SET_COUNTRY = `${SAILS_APP_NAME}/SET_COUNTRY`;
/** SET_TARIFF */
export const SET_TARIFF = `${SAILS_APP_NAME}/SET_TARIFF`;
/** GET_ROAMING_OPTIONS_SUCCESS */
export const GET_ROAMING_OPTIONS_SUCCESS = `${SAILS_APP_NAME}/GET_ROAMING_OPTIONS_SUCCESS`;
/** GET_ROAMING_OPTIONS_SUCCESS */
export const GET_ROAMING_OPTIONS_FAILED = `${SAILS_APP_NAME}/GET_ROAMING_OPTIONS_FAILED`;

/** LOADING_INDICATOR_CONTAINER */
export const LOADING_INDICATOR_CONTAINER = 'sails-ra-loading-spinner';
/** LOADING_INDICATOR_CONTAINER */
export const NOTIFICATION_CONTAINER = 'sails-ra-error';
/** SUGGEST_FIELD_CONTAINER */
export const SUGGEST_FIELD_CONTAINER = 'sails-ra-suggest-field';

/** ROAMING_OPTIONS_CONTAINER */
export const RESULTS = 'sails-ra-results';

/** ROAMING_OPTIONS_CONTAINER */
export const ROAMING_OPTIONS_CONTAINER = 'sails-ra-results-list';
/** OPTION_PICKER_DESTINATION */
export const OPTION_PICKER_DESTINATION = 'sails-ra-option-picker-destination';
/** OPTION_PICKER_TARIFF */
export const OPTION_PICKER_TARIFF = 'sails-ra-option-picker-tariff';
/** STEP_01 */
export const STEP_01 = 'sails-ra-step01';
/** STEP_02 */
export const STEP_02 = 'sails-ra-step02';
/** STEP_03 */
export const STEP_03 = 'sails-ra-step03';

/**
 * createOptionVO
 */
export const createOptionVO = (stdValue: string): OptionVO => ({
    stdText: getRaLocale(stdValue),
    stdValue,
});

/**
 * Destination
 */

/**
 *
 */
export enum Destination {
    /* eslint-disable @typescript-eslint/naming-convention */
    inForeignCountry = 'inForeignCountry',
    toForeignCountry = 'toForeignCountry',
    inForeignCountrySmartDevice = 'inForeignCountrySmartDevice',
    /* eslint-enable @typescript-eslint/naming-convention */

}

/**
 * DESTINATIONS
 */
export const DESTINATIONS = [
    createOptionVO(Destination.inForeignCountry),
    createOptionVO(Destination.toForeignCountry),
    createOptionVO(Destination.inForeignCountrySmartDevice),

];

/**
 * AVAILABLE_TARIFFS
 */
export const AVAILABLE_TARIFFS = [
    createOptionVO('gigaMobilOrGigaMobilYoung'),
    createOptionVO('redOrYoung'),
    createOptionVO('familyCard'),
    createOptionVO('smart'),
    createOptionVO('easy'),
    createOptionVO('other'),
];
/**
 * AVAILABLE_TARIFFS_02
 */
export const AVAILABLE_TARIFFS_02 = [
    createOptionVO('smartTechS'),
    createOptionVO('smartTechM'),
    createOptionVO('smartTechL'),
];

/**
 * RoamingRestriction
 */
export enum RoamingRestriction {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    notInHomeCountry = 'NOT_IN_HOME_COUNTRY',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    notInForeignCountry = 'NOT_IN_FOREIGN_COUNTRY',
}
/* eslint-disable @typescript-eslint/naming-convention */
/**
 * UI_STATE
 */
export enum UI_STATE {
    SELECT_DESTINATION = 'SELECT_DESTINATION',
    SELECT_COUNTRY = 'SELECT_COUNTRY',
    NO_ROAMING_FOR_SELECTION = 'NO_ROAMING_FOR_SELECTION',
    SELECT_TARIFF = 'SELECT_TARIFF',
    TARIFF_SELECTED = 'TARIFF_SELECTED',
    DISPLAY_OPTIONS = 'DISPLAY_OPTIONS',
}
/* eslint-enable @typescript-eslint/naming-convention */

/**
 * serviceUrl
 */
export const serviceUrl = 'http://localhost:3000';
